import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=a18423e6&"
import script from "./WhatsApp.vue?vue&type=script&lang=ts&"
export * from "./WhatsApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports